import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { LoginComponent } from "./components/login/login.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { SampleSearchComponent } from "./components/sample-search/sample-search.component";
import { SampleDetailComponent } from './components/sample-detail/sample-detail.component';
import { SampleCorrectionComponent } from './components/sample-correction/sample-correction.component';
import { PreLogEntryComponent } from './components/pre-log-entry/pre-log-entry.component';
import { PreLogReviewComponent } from './components/pre-log-review/pre-log-review.component';
import { PreLogCompleteComponent } from './components/pre-log-complete/pre-log-complete.component';
import { PreLogDetailComponent } from './components/pre-log-detail/pre-log-detail.component';
import { Permission } from './interfaces/permission.enum';

const routes: Routes = [
  { path: '', redirectTo: '/sample-search', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'sample-search', component: SampleSearchComponent, canActivate: [AuthGuardService], data: { permission: Permission.SearchDNASamples } },
  { path: 'sample/:id/correction', component: SampleCorrectionComponent, canActivate: [AuthGuardService], data: { permission: Permission.CreateSampleCorrection } },
  { path: 'sample/:id', component: SampleDetailComponent, canActivate: [AuthGuardService], data: { permission: Permission.ViewDNASamples } },
  { path: 'pre-log', component: PreLogEntryComponent, pathMatch: 'full', canActivate: [AuthGuardService], data: { permission: Permission.CreatePreLog } },
  { path: 'pre-log/review', component: PreLogReviewComponent, canActivate: [AuthGuardService], data: { permission: Permission.CreatePreLog } },
  { path: 'pre-log/ready-to-send', component: PreLogCompleteComponent, canActivate: [AuthGuardService], data: { permission: Permission.CreatePreLog } },
  { path: 'pre-log/:id', component: PreLogDetailComponent, canActivate: [AuthGuardService], data: { permission: Permission.ViewPreLog } },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
  PageNotFoundComponent,
  LoginComponent,
  LogoutComponent,
  SampleDetailComponent,
  SampleCorrectionComponent,
  SampleSearchComponent,
  PreLogEntryComponent,
  PreLogReviewComponent,
  PreLogCompleteComponent,
  PreLogDetailComponent
];
